export class ImportCounters {
  constructor(
    public readonly total: number,
    public readonly activated: number,
    public readonly prospect: number,
    public readonly waitingToBeInvited: number,
  ) {}
}
